//package import
import { useState, useEffect, useRef, useMemo } from 'react'
import { useLazyQuery, useMutation } from '@apollo/client'
//system import
import '../../../../shared-css/Global.css'
import { alert, areYouSurePrompt } from '../../../../../utils/helper'
import DownloadCsv from '../../../Download/DownloadCsv'
import SearchList from '../../../../sharedComponent/SearchList/SearchList'
import {
  filterDataFeedHelper,
  smartDocsFilterType,
} from '../../../../../utils/TeamAdmin/SmartDocsUtils'
import { SMARTDOCSLISTCONFIGS } from '../../../../../utils/TeamAdmin/SmartDocsUtils'
import { dropdownMenuItemsType } from '../../../../sharedComponent/SearchList/SearchList.types'
import { filterConfig } from '../../../../../utils/Global.types'
import { GLOBAL_CONSTANTS } from '../../../../../utils/GlobalConstants'
import Filter from '../../../../sharedComponent/Filter'
import plusIcon from '../../../../../_metronic/images/smlplus.svg'
import { AddSmartDocsComponent } from '../addDocs/AddDocs'
import { GET_ALL_SMART_DOCS_AND_FILTER, DELETE_SMART_DOCS, CREATE_SMART_DOCS } from '../../../../../utils/GraphQLAPI'

const csvHeaders = [
  { label: 'Document Name', key: 'DocumentName' },
  { label: 'Document Type', key: 'DocumentType' },
  { label: 'Language', key: 'Language' },
  { label: 'Contract Type', key: 'ContractType' },
  { label: 'Customer Type', key: 'CustomerType' },
  { label: 'State', key: 'State' },
  { label: 'Utility', key: 'Utility' },
  { label: 'Commodity', key: 'Commodity' },
  { label: 'Products', key: 'Products' },
  { label: 'Status', key: 'isActive' },
]


const defaultDocumentFilter = {
  page: 1,
  limit: 10,
  perPage: 10,
  searchQuery: '',
  documentStatus: null,
  commodityId: null,
  contractTypeId: null,
  utilityId: null,
  state: null,
}

const SmartDocsList = ({
  filterData,
  featureFlags,
  SetUp
}: {
  filterData?: any
  featureFlags?: boolean
  SetUp: string
}) => {
  const csvRef = useRef<any>(null)
  const [createModal, setCreateModal] = useState<string>('create')
  const [smartDocsId, setSmartDocsId] = useState<any>()
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [filterFeed, setFilterFeed] = useState<filterConfig[]>([])
  const [filterOptions, setFilterOptions] = useState<any>(defaultDocumentFilter)

  const [getSmartDocs, { loading, data: smartDocsList }] = useLazyQuery(
    GET_ALL_SMART_DOCS_AND_FILTER,
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      onError: (err) => console.log('error', err),
    }
  )
  const [getSmartDocss, { data: smartDocsLists }] = useLazyQuery(
    GET_ALL_SMART_DOCS_AND_FILTER,
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      onError: (err) => console.log('error', err),
    }
  )
  const downloadDatas = useMemo(() => {
    const data = smartDocsLists?.fetchAllSmartDocuments?.data ?? []

    return data.map((doc: any) => {
      const products =
        doc.smartDocProducts?.length
          ? Array.from(
            new Set(
              doc.smartDocProducts
                .map((item: any) => item?.product?.name)
                .filter(Boolean)
            )
          ).join(', ')
          : ''

      return {
        DocumentName: doc.documentName ?? '',
        DocumentType: doc.documentTypes?.documentType ?? '',
        Language: doc.language?.languageName ?? '',
        ContractType: doc.contractType?.name ?? '',
        CustomerType: doc.customerType?.name ?? '',
        State: doc.stateDetail?.name ?? '',
        Utility: doc.utility?.name ?? '',
        Commodity: doc.commodity?.name ?? '',
        Products: products,
        isActive: doc.isActive ? 'Active' : 'Inactive',
      }
    })
  }, [smartDocsLists])


  const buildSmartDocsFilter = (uiFilter: any) => ({
    page: uiFilter.page ?? 1,
    limit: uiFilter.perPage ?? uiFilter.limit ?? 10,
    searchQuery: uiFilter.searchText ?? uiFilter.searchQuery ?? '',
    documentStatus: uiFilter.documentStatus ?? null,
    commodityId: uiFilter.Commodity ?? uiFilter.commodityId ?? null,
    contractTypeId: uiFilter.ContractTypeId ?? uiFilter.contractTypeId ?? null,
    utilityId: uiFilter.utilityId ?? null,
    state: uiFilter.State ?? uiFilter.state ?? null,
  })

  useEffect(() => {
    const apiFilter = buildSmartDocsFilter(filterOptions)
    getSmartDocs({
      variables: {
        filter: apiFilter,
      },
    })
  }, [filterOptions])

  const [addAndUpdateSmartDocs] = useMutation(CREATE_SMART_DOCS, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
    onCompleted: () => {
      alert('Update Successfully', 'success')
      getSmartDocs()
    },
    onError: (e) => {
      alert(e.message, 'error')
    },
  })

  /// set the filter option from the api
  useEffect(() => {
    if (filterData?.getAllInputValuesAtDocCreation?.constructedInputs?.length > 0) {
      let filterDataFromApi: any[] =
        filterData?.getAllInputValuesAtDocCreation?.constructedInputs
          .filter(
            (value: any) =>
              value.enum === 'UTILITY' ||
              value.enum === 'STATE' ||
              value.enum === 'CONTRACT_TYPE' ||
              value.enum === 'COMMODITY'
          )
          .map((value: any) => ({
            enum: value.enum,
            names:
              value.enum === 'STATE'
                ? value.names
                  .slice(1)
                  .map(({ id, value }: { id: string; value: string }) => ({
                    id,
                    value,
                  }))
                : value.names.map(({ id, value }: { id: string; value: string }) => ({
                  id,
                  value,
                })),
          }));
      const selectedFilterData = filterDataFromApi

      let filterDataTemp: smartDocsFilterType[] = [
        ...selectedFilterData,
        {
          enum: 'DOCUMENT_STATUS',
          names: [
            {
              id: 'active',
              value: 'Active',
            },
            {
              id: 'in_active',
              value: 'Inactive',
            },
          ],
        },
      ]
      //to set filter dropdown configuration state
      setFilterFeed(() =>
        filterDataTemp.map((value) => filterDataFeedHelper(value.names, value.enum))
      )
    }
  }, [filterData])

  //Delete product
  const [deleteSmartDocs] = useMutation(DELETE_SMART_DOCS, {
    onCompleted: (data) => {
      alert('Smart Document deleted successfully', 'success')
      getSmartDocs()
    },
    onError: (err) => alert(err.message, 'error'),
    fetchPolicy: 'network-only',
  })


  const openModal = (id: string, type?: string, value?: any) => {
    setShowCreateAppModal(true)
    if (type === 'edit') {
      setCreateModal('edit')
      setSmartDocsId(id)
    } else if (type === 'Create') {
      setCreateModal(type)
      setSmartDocsId('')
    } else if (type === 'clone') {
      setCreateModal('clone')
      setSmartDocsId(id)
    }
    else if (type === 'preview') {
      setCreateModal('preview')
      setSmartDocsId(id)
    }
  }

  const handleCloseModal = () => {
    setShowCreateAppModal(false)
  }

  //list dropdown configuration
  const dropdownMenuItems: dropdownMenuItemsType[] = [
    {
      name: 'Edit',
      callBack: openModal,
    },
    {
      name: 'Clone',
      callBack: openModal,
    },
    {
      name: 'Preview',
      callBack: openModal,
    },
    {
      name: 'ACTIVATION',
      callBack: (id, val, value) => {
        const payload = {
          documentName: value.documentName,
          documentTypeId: value.documentTypes?.smartDocDetailsId,
          languageId: value.language?.id,
          isActive: !value.isActive,
        }
        addAndUpdateSmartDocs(
          {
            variables: {
              id: id,
              data: payload
            }
          }
        )
      }
    },

    {
      name: 'Delete',
      callBack: (id) => {
        areYouSurePrompt(
          'Are you sure?',
          () => {
            deleteSmartDocs({
              variables: {
                smartDocId: id,
              },
            })
          },
          () => { },
          'Yes, delete it',
          'No, cancel !',
          `You won't be able to revert this`
        )


      },
      textColor: 'text-danger',
    },
  ]

  const csvDownloadFun = async () => {
    const buildSmartDocsFilter = () => ({
      page: 1,
      limit: 1000,
      searchQuery: '',
      documentStatus: null,
      commodityId: null,
      contractTypeId: null,
      utilityId: null,
      state: null,
    })
    const apiFilter = buildSmartDocsFilter()
    await getSmartDocss({
      variables: {
        filter: apiFilter,
      },
    })
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  return (
    <SearchList
      filterOptions={filterOptions}
      setFilterOptions={setFilterOptions}
      apiData={smartDocsList?.fetchAllSmartDocuments?.data || []}
      listLoading={loading}
      listCount={smartDocsList?.fetchAllSmartDocuments?.total}
      paginatedCount={smartDocsList?.fetchAllSmartDocuments?.data?.length}
      listConfigs={SMARTDOCSLISTCONFIGS}
      onRowClick={(rowData: any) =>
        openModal(rowData.smartDocId, 'edit')
      }
      IsSmartDocsList={true}
      idFieldName='smartDocId'
      isActiveApiFieldName={'isActive'}
      PlaceholderText='Search Document'
      dropdownMenuItems={dropdownMenuItems}
      toolbar={
        <>
          <DownloadCsv
            csvDownloadFun={csvDownloadFun}
            reload={false}
            csvHeaders={csvHeaders}
            csvRef={csvRef}
            downloadData={downloadDatas}
            downloadFileName='documents.csv'
          />

          <Filter
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            filterConfig={filterFeed}
            initialFilter={defaultDocumentFilter}
          />

          <button
            className='btn btn-primary fs-6 px-5 py-3 ms-5'
            onClick={(e) => openModal('', 'Create')}
          >
            <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
            <span>Create SmartDocs </span>
          </button>
          {showCreateAppModal &&
            <AddSmartDocsComponent handleClose={handleCloseModal} show={showCreateAppModal} method={createModal} editId={smartDocsId} refetchDocs={getSmartDocs} SetUp={SetUp} />
          }
        </>
      }
    />
  )
}
export default SmartDocsList
